(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-gyrol-evolution]').forEach((carousel) => {
      if (carousel.dataset.initialized === 'true') return;
      carousel.dataset.initialized = 'true';

      const track = carousel.querySelector('[data-evolution-track]');
      const slides = Array.from(carousel.querySelectorAll('[data-evolution-slide]'));
      const previous = carousel.querySelector('[data-evolution-prev]');
      const next = carousel.querySelector('[data-evolution-next]');
      const currentLabel = carousel.querySelector('[data-evolution-current]');
      const progress = carousel.querySelector('[data-evolution-progress]');

      if (!track || slides.length < 1) return;
      let activeIndex = 0;
      let frameRequested = false;

      const findActiveIndex = () => {
        const firstOffset = slides[0].offsetLeft;
        let closestIndex = 0;
        let closestDistance = Infinity;
        slides.forEach((slide, index) => {
          const distance = Math.abs(slide.offsetLeft - firstOffset - track.scrollLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });
        return closestIndex;
      };

      const update = () => {
        frameRequested = false;
        activeIndex = findActiveIndex();
        if (currentLabel) currentLabel.textContent = String(activeIndex + 1).padStart(2, '0');
        if (previous) previous.disabled = activeIndex === 0;
        if (next) next.disabled = activeIndex === slides.length - 1;
        if (progress) progress.style.transform = `scaleX(${(activeIndex + 1) / slides.length})`;
      };

      const queueUpdate = () => {
        if (frameRequested) return;
        frameRequested = true;
        window.requestAnimationFrame(update);
      };

      const moveTo = (index) => {
        const boundedIndex = Math.max(0, Math.min(slides.length - 1, index));
        track.scrollTo({
          left: slides[boundedIndex].offsetLeft - slides[0].offsetLeft,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      };

      previous?.addEventListener('click', () => moveTo(findActiveIndex() - 1));
      next?.addEventListener('click', () => moveTo(findActiveIndex() + 1));
      track.addEventListener('scroll', queueUpdate, { passive: true });
      window.addEventListener('resize', queueUpdate, { passive: true });
      queueUpdate();
    });
  };

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
